import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import api from "../Utility/api";
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL || ""}/api/magic-request`,
        { email },
      );
      setSent(true);
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Unable to send a login link. Please try again.",
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <Container maxWidth="xs" sx={{ pt: 7 }}>
      <Paper elevation={6} sx={{ p: 4 }}>
        <span className="eyebrow">Find your way back</span>
        <Typography variant="h4" component="h1" mb={2}>
          Lost your password?
        </Typography>
        <Typography color="text.secondary" mb={3}>
          We’ll send a link to sign in. Then you can change your password from
          your profile.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {sent && (
          <Alert severity="success" sx={{ mb: 2 }}>
            If an account exists for this email, a sign-in link is on its way.
            It expires in 15 minutes.
          </Alert>
        )}
        <Box component="form" onSubmit={submit}>
          <Stack gap={2}>
            <TextField
              label="Email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              fullWidth
            />
            <Button variant="contained" type="submit" disabled={busy}>
              {busy ? "Sending…" : "Send sign-in link"}
            </Button>
          </Stack>
        </Box>
        <Typography variant="body2" mt={3}>
          <Link to="/login">Back to sign in</Link>
        </Typography>
      </Paper>
    </Container>
  );
}
